import {hasImage} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../../../../hooks/runtime'
import {getEvent} from '../../../../../selectors/event'
import {EventImage} from '../../../../event-image'
import s from './image.scss'

export const Image = () => {
  const event = useAppSelector(getEvent)

  return hasImage(event) ? <EventImage className={classNames(s.container)} doubleHeight /> : null
}
